import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LayoutService, NotificationsService, UserService } from '@pragma/services';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { ToastModule } from 'primeng/toast';
import { DefaultImageDirectiveModule } from '../../directives/image/image-directive.module';
import { ButtonModule } from 'primeng/button';
import { UserDto } from '@pragma/dto';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
    standalone: true,
    selector: 'ngx-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule, AvatarModule, MenuModule, ToastModule, DefaultImageDirectiveModule, ButtonModule]
})
export class FooterComponent implements OnInit {
    user: UserDto | undefined;
    items!: MenuItem[];
    currentLang: string;

    constructor(
        public layoutService: LayoutService,
        private _userService: UserService,
        private _router: Router,
        private _notificationService: NotificationsService,
        private _translateService: TranslateService,
        private _cd: ChangeDetectorRef
    ) {
        this.items = [];
        this.initializeMenuItems();
        this.currentLang = this._translateService.currentLang || 'en';
    }

    ngOnInit(): void {
        this.subscribeToUser();

        this._translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            this.currentLang = event.lang;
            this.initializeMenuItems();
            this._cd.detectChanges();
        });
    }

    private navigateProfile(): void {
        this._router.navigate(['pages/profile']);
    }

    private logout() {
        this._userService.logout();
        this._router.navigate(['auth/login']);
    }

    private subscribeToUser(): void {
        this._userService.user.subscribe({
            next: (user) => {
                this.user = user;
                this._cd.detectChanges();
            },
            error: () => {
                const title = this._translateService.instant('errors.user.subscription');
                const message = this._translateService.instant('errors.user.loadData');
                this._notificationService.displayError(title, message);
            }
        });
    }

    private initializeMenuItems(): void {
        this.items = [
            {
                label: this._translateService.instant('sidebar.header.subMenu.account'),
                icon: 'material-icons mi-account-circle',
                command: () => {
                    this.navigateProfile();
                }
            },
            {
                label: this._translateService.instant('sidebar.header.subMenu.logout'),
                icon: 'material-icons mi-logout',
                command: () => {
                    this.logout();
                }
            }
        ];
    }
}
